import Image from "next/image"
import { Anchor } from "../../app/components/anchor"
import { readImage } from "@/app/utils/read-image"
import { safelyRenderHtml } from "@/util/safelyRenderHtml"
import { marked } from "marked"

export default function PetTransportCoverage() {
  const header = "Our promise: safe and happy pets at every step"
  const subheader =
    "Your pets aren't just four legs and a tail; they're cherished family members. As the top-rated pet transportation marketplace, we connect you with a selection of trusted drivers through our unique process."
  const blocks = [
    {
      icon: {
        alt: "privacy",
        src:
          "https://a-us.storyblok.com/f/1002522/64x64/b3f07a12d1/data-privacy-1.png/m/",
      },
      title: "$1k Pet Protection Coverage",
      markdown:
        "Up to $1,000 pet protection guarantee to give you peace of mind when booking.",
    },
    {
      icon: {
        alt: "healthcare",
        src:
          "https://a-us.storyblok.com/f/1002522/64x64/f38832d31b/healthcare-1.png/m/",
      },
      title: "24/7 TeleVet Access",
      markdown: "Through our partner Vetster. Just in case.",
    },
    {
      icon: {
        alt: "colllaboration",
        src:
          "https://a-us.storyblok.com/f/1002522/64x64/e2554fc2a2/handshake-1.png/m/",
      },
      title: "Booking Assurance Guarantee",
      markdown:
        "From quote to delivery, so you can select and ship with confidence.",
    },
    {
      icon: {
        alt: "trust",
        src:
          "https://a-us.storyblok.com/f/1002522/64x64/2e52526d55/trusted-user-1.png/m/",
      },
      title: "Caring Drivers You Can Trust",
      markdown:
        "Thorough background checks, direct driver contact, and thousands of reviews. Your pet deserves only the best care.",
    },
  ]

  return (
    <section
      id="our-promise__local"
      className="px-6 md:px-8 lg:px-16 max-w-[1400px] w-full mx-auto mt-4 pt-8 lg:pt-10"
    >
      <article className={"my-4 lg:my-24 text-left lg:text-center"}>
        <h3 className="font-merriweather font-normal text-4xl mb-6 text-center leading-[72px] max-w-4xl mx-auto">
          {header}
        </h3>
        <div className="max-w-4xl mb-16 mx-auto text-center text-2xl leading-9">
          {subheader}
        </div>
        <section className="grid grid-cols-1 md:grid-cols-2 xl:px-20 gap-6">
          {blocks?.map(({ icon, title, markdown }, i) => (
            <div
              key={i}
              className="p-6 md:p-8 border border-black font-merriweather text-left"
            >
              <Image
                className="w-16 h-16 mb-4 object-cover"
                alt={icon.alt}
                src={readImage(icon)}
                height={64}
                width={64}
                loading="lazy"
              />

              {title && <h4 className="text-2xl text-inherit mb-6">{title}</h4>}
              <div className="max-w-none font-inter prose-h4:text-xl prose-h4:text-black prose-h4:font-normal prose-p:text-[16px]">
                {safelyRenderHtml(marked.parse(markdown))}
              </div>
            </div>
          ))}
        </section>
      </article>
    </section>
  )
}
